module.exports = __webpack_public_path__ + "img/1052.27889bea.gif";